import * as Yup from 'yup';

/** Yup schema for create/edit Aging form. Completed requires an end date. */
export const AgingSchema = Yup.object().shape({
  batch_id: Yup.number().required('Wine batch is required'),
  vesselId: Yup.number().required('Vessel is required'),
  start_date: Yup.date().required('Start date is required'),
  end_date: Yup.date()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .nullable()
    .when('status', {
      is: 'Completed',
      then: (schema) => schema.required('End date is required when status is Completed'),
      otherwise: (schema) => schema.notRequired(),
    }),
  status: Yup.string().required('Status is required'),
  notes: Yup.string(),
});
